module.exports = __webpack_public_path__ + "static/img/out2.32a02818.png";